import * as React from 'react';
import { connect } from 'react-redux';
import KPNumberSelector from '../../SSPCustomComponentLibrary/KPNumberSelector/KPNumberSelector';

class KPNumberSelectorPage extends React.Component<any, any>  {
    constructor(props) {
        super(props);
        this.state = {
            value: 0,
            min: 0,
            max: 10,
            increment: 1,
            decimalValue: 0.2,
            decimalMin: 0,
            decimalMax: 1,
            inline: true,
            rerender: false,
        };

        this.switchStyling = this.switchStyling.bind(this);
        this.handleChange = this.handleChange.bind(this);
        this.handleChangeDecimal = this.handleChangeDecimal.bind(this);
    }

    async switchStyling(value: boolean) {
        await this.setState({
            inline: value,
            rerender: true,
        });

        await this.setState({
            rerender: false,
        });
    }

    handleChange(newValue: number, name: string) {
        this.setState({
            [name]: newValue
        });
    }

    handleChangeDecimal(newValue: number, name: string) {
        this.setState({
            [name]: newValue
        });
    }

    public render() {
        return (
            <div id="appContainer" className="noProfile styling-project">
                <div className="styling-foundation-page-header">
                    SSP KP Number Selector Component
                </div>
                <div className="row">
                    <div className="col-md-6 offset-md-3">
                        <div className="styling-foundation-input-container-large mt-4" style={{ width: "unset" }}>
                            <div className="row">
                                <div className="col-12">
                                    <KPNumberSelector
                                        label="Geyser"
                                        increment={1}
                                        currentValue={this.state.value}
                                        inline={true}
                                        handleChange={this.handleChange}
                                        valueName="value"
                                    />
                                </div>
                                <div className="col-12">
                                    <KPNumberSelector
                                        label="Bedrooms"
                                        increment={0.1}
                                        currentValue={this.state.decimalValue}
                                        inline={false}
                                        handleChange={this.handleChangeDecimal}
                                        valueName="decimalValue"
                                        minValue={this.state.decimalMin}
                                        maxValue={this.state.decimalMax}
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}

const mapStateToProps = (state: any) => {
    return {
        props: state.loadingScreen,
    }
}

const mapDispatchToProps = (dispatch: any) => {
    return {}
}

export default connect(mapStateToProps, mapDispatchToProps)(KPNumberSelectorPage)